import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetNewsListActionType {
  Reset = 'newsList/resetNewsList',
}

export type TResetNewsList = ITypedReduxAction<EResetNewsListActionType.Reset>;
